import React from "react";
import { Icon } from "@shared/components";

import "./index.scss";

interface NoMatchesFoundProps {
  label?: string;
  // 923-core-context context/engineering/procedure-assistant/bug-fixing/improvement-02-semantic-search-from-no-matches.md: optional slot for a caller-supplied action under
  // the label (e.g. Procedure's "Try semantic search" / "Back to regular search" hints). Every other
  // caller passes only `label` or nothing, so leaving this undefined must render byte-identical to before.
  children?: React.ReactNode;
}

const NoMatchesFound = (props: NoMatchesFoundProps) => {
  const { label = "No matches found", children } = props;
  return (
    <div className="no-matches-found">
      <Icon type="not-found" />
      <div className="no-matches-label">{label}</div>
      {children ? <div className="no-matches-extra">{children}</div> : null}
    </div>
  );
};

export default NoMatchesFound;
